import React from "react";
import "./AboutUs.css";

import founder1 from "../../assets/Anmol2.png";
import founder2 from "../../assets/Deepak .png";
import founder3 from "../../assets/Divesh.jpeg";
import founder4 from "../../assets/Shriya .jpg";

import travel from "../../assets/MainAboutUs.png";
// import travel from '../../assets/travel.jpg'
import aboutTheCompany from "../../assets/aboutUs2.png";
import unique from "../../assets/unique.png";
import jounry from "../../assets/jounry.jpg";
import vision from "../../assets/OurVision.jpg";

const AboutUs = () => {
  return (
    <div className="about-us">
      <div className="banner">
        <img src={travel} alt="ZikRme Banner" />
        {/* <h1 class="zikrme-text">ZikRme</h1> */}
      </div>

      <section className="section alternate-odd ">
        <div className="section-content">
          <div className="text">
            <h2>About the Company</h2>
            <p>
              ZikRme is India’s leading all-in-one travel and booking platform,
              redefining how people explore, experience, and connect with the
              world around them. Whether you're a curious traveler, a
              thrill-seeker, a digital creator, or a business — ZikRme is your
              one-stop destination.
            </p>
            <p>
              We offer hotel bookings, cab reservations, restaurant dining,
              adventure park tickets, and travel insights — combining
              technology, trust, and tourism like never before.
            </p>
          </div>
          <div className="image section-aboutUsImg">
            <img src={aboutTheCompany} alt="About ZikRme" />
            <p>ZikRme</p>
          </div>
        </div>
      </section>

      <section className="section alternate">
        <div className="section-content">
          <div className="image">
            <img src={jounry} alt="Our Journey" />
          </div>
          <div className="text">
            <h2>Our Journey</h2>
            <p>
              ZikRme began with a simple goal: to bridge the gap between
              travelers and authentic local experiences. From a small initiative
              to a national platform, we now offer:
            </p>
            <ul>
              <li>
                B2B solutions for hotels, restaurants, cabs, and adventure parks
              </li>
              <li>Travel planning for consumers</li>
              <li>A space for influencers and enthusiasts</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section  alternate-odd">
        <div className="section-content">
          <div className="text">
            <h2>What Makes ZikRme Unique?</h2>
            <h4>For Travelers</h4>
            <ul>
              <li>In-depth guides, tips, and verified reviews</li>
              <li>Earn cashback and bonuses</li>
              <li>Collaborate and monetize travel stories</li>
            </ul>
            <h4>For Businesses</h4>
            <ul>
              <li>Verified listings and bookings</li>
              <li>Grow reach with our platform</li>
              <li>ZikRme Business Program</li>
            </ul>
            <h4>For Job Seekers</h4>
            <ul>
              <li>Internships and career paths</li>
              <li>Real-world mentorship</li>
            </ul>
          </div>
          <div className="image">
            <img src={unique} alt="Unique Features" />
          </div>
        </div>
      </section>

      <section className="section alternate">
        <div className="section-content">
          <div className="image">
            <img src={vision} alt="Vision and Mission" />
          </div>
          <div className="text">
            <h2>Our Vision</h2>
            <p>
              To become India’s most trusted and innovative travel ecosystem
              where:
            </p>
            <ul>
              <li>Travelers explore the unexplored</li>
              <li>Businesses grow through technology</li>
              <li>Influencers inspire experiences</li>
            </ul>

            <h2>Our Mission</h2>
            <ol>
              <li>Empower Travelers</li>
              <li>Support Businesses</li>
              <li>Encourage Exploration</li>
              <li>Unify Travel Ecosystems</li>
            </ol>
          </div>
        </div>
      </section>

      <section className="founders">
        <h2>Our Team</h2>
        <div className="founder-container">
          <div className="founder-card">
            <img src={founder1} alt="Anmol Upadhyaya" />
            <h3>Anmol Upadhyaya</h3>
            <p>Vision-led founder with sharp foresight</p>
          </div>
          <div className="founder-card">
            <img src={founder2} alt="Deepak Tomar" />
            <h3>Deepak Tomar</h3>
            <p>Finance brain behind steady growth</p>
          </div>
          <div className="founder-card">
            <img src={founder3} alt="Divesh Upadhyay" />
            <h3>Divesh Upadhyay</h3>
            <p>Operational anchor ensuring seamless flow</p>
          </div>
          <div className="founder-card">
            <img src={founder4} alt="Shriya Chaturvedi" />
            <h3>Shriya Chaturvedi</h3>
            <p>Tech-driven mind powering innovation</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
